import { MenuMetaPill } from '@/components/printMenu/MenuMetaPill'
import { cn } from '@/lib/utils'

type MenuServiceMetaRowProps = {
  durationMin?: number
  price?: string
  mostPopular?: boolean
  className?: string
}

export function MenuServiceMetaRow({
  durationMin,
  price,
  mostPopular,
  className,
}: MenuServiceMetaRowProps) {
  if (durationMin == null && !price && !mostPopular) return null

  return (
    <div className={cn('mt-3.5 flex flex-wrap items-center gap-2', className)}>
      {durationMin != null ? <MenuMetaPill>{durationMin} min</MenuMetaPill> : null}
      {price ? (
        <MenuMetaPill variant="price">
          <span className="tabular-nums tracking-normal">{price}</span>
        </MenuMetaPill>
      ) : null}
      {mostPopular ? <MenuMetaPill variant="popular">Popular</MenuMetaPill> : null}
    </div>
  )
}
